<template>
	<div class="coupon-wrapper" @click="choose">
		<!-- 现金劵 -->
		<div v-if="type !== 2" class="left">
			<div class="price">
				<div class="unit">￥</div>
				<div class="val">{{ fenToYuan(dataSource.money) }}</div>
			</div>
			<div class="line"></div>
		</div>
		<!-- 活动劵 -->
		<div v-else class="left">
			<img src="../../../assets/img-v2/ic_coupon_activity.png" class="icon" />
			<div class="line"></div>
		</div>
		<div class="right">
			<div class="content">
				<div class="title">
					{{ dataSource.couponTemplateName }}
				</div>
				<div class="desc">有效期至 {{ dataSource.endDate | dateTime }}</div>
			</div>
			<img :src="require(`../../../assets/img-v2/ic_coupon_radio${activeId === id ? '_selected': ''}.png`)" class="btn" />
		</div>
	</div>
</template>

<script>
import { fenToYuan } from '@/utils';

const DO_NOT_USE_COUPON = 'no'

export default {
	name: 'couponChooseCard',
	props: {
		dataSource: {
			type: Object,
			default() {
				return {};
			},
		},
		activeId: {
			type: [Number, String],
		},
	},
	data() {
		return {
		};
	},
	computed: {
		id() {
			return this.dataSource.couponId;
		},
		type() {
			return this.dataSource.type;
		},
	},
	filters: {
		dateTime(val) {
			return val && val.substr(0, 10);
		},
	},
	methods: {
		fenToYuan,
		choose() {
			const data = this.activeId === this.id ? DO_NOT_USE_COUPON : this.id;
			this.$emit('choose', data);
		},
	},
};
</script>

<style lang="scss" scoped>
.coupon-wrapper {
  width: 100%;
	position: relative;
	box-sizing: border-box;
	background: #ffffff;
	display: flex;
	margin-bottom: 10px;
	border-radius: 12px;
	box-shadow: 0px 0px 4px 0px #D7E3EA;
	overflow: hidden;

	.left {
		width: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.price {
		display: flex;
		align-items: baseline;
	}

	.unit {
		font-family: DINAlternate, DINAlternate;
		font-weight: bold;
		font-size: 14px;
		color: #FE5959;
		line-height: 16px;
		text-align: right;
		font-style: normal;
	}

	.val {
		font-family: DINAlternate, DINAlternate;
		font-weight: bold;
		font-size: 28px;
		color: #FE5959;
		line-height: 32px;
		text-align: left;
		font-style: normal;
	}

	.line {
		position: absolute;
		top: 12px;
		bottom: 12px;
		right: 0;
		border: 1px dashed #eeeeee;
		display: flex;
		justify-content: center;
		&::before {
			content: '';
			position: absolute;
			top: -20px;
			width: 12px;
			height: 12px;
			background: #F3F4F5;
			border-radius: 50%;
		}
		&::after {
			content: '';
			position: absolute;
			bottom: -20px;
			width: 12px;
			height: 12px;
			background: #F3F4F5;
			border-radius: 50%;
		}
	}

	.icon {
		width: 38px;
		height: 38px;
	}

	.right {
		flex: 1;
		padding: 16px 14px 14px 9px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.content {
		display: flex;
		flex-direction: column;
	}

	.title {
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 16px;
		color: #000000;
		line-height: 22px;
		text-align: left;
		font-style: normal;
	}

	.desc {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #999999;
		line-height: 20px;
		text-align: left;
		font-style: normal;
	}

	.btn {
		width: 20px;
		height: 20px;
	}
}
</style>
